import { EditLqsResourceForm, useTag, useUpdateTag } from "~/lqs";
import { lqsRoutePaths, useLqsNavigator, useTypedParams } from "~/paths";
import { selectData } from "~/utils";
import { editTagSchema } from "../schemas";

export function TagEditForm() {
  const { logId, tagId } = useTypedParams(lqsRoutePaths.LOG_TAG_EDIT);

  const lqsNavigator = useLqsNavigator({ toLogTagDetails: true });

  return (
    <EditLqsResourceForm
      resourceName="tag"
      registryKey="tag"
      query={useTag(logId, tagId, { select: selectData })}
      schema={editTagSchema}
      descriptors={[
        {
          name: "labelId",
          type: "foreign-key",
          resourceType: "label",
          required: true,
        },
        {
          name: "topicId",
          type: "foreign-key",
          resourceType: "topic",
          additionalProps: { logId },
        },
        { name: "startTime", type: "timestamp" },
        { name: "endTime", type: "timestamp" },
        { name: "note", type: "text", multiline: true },
        { name: "context", type: "json" },
      ]}
      mutation={useUpdateTag(logId, tagId)}
      detailsLocation={lqsNavigator.toLogTagDetails({ logId, tagId })}
    />
  );
}
